import { render, staticRenderFns } from "./examinationInfo.vue?vue&type=template&id=5db91315&scoped=true&"
import script from "./examinationInfo.vue?vue&type=script&lang=js&"
export * from "./examinationInfo.vue?vue&type=script&lang=js&"
import style0 from "./examinationInfo.vue?vue&type=style&index=0&id=5db91315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db91315",
  null
  
)

export default component.exports